import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Jstring(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
  <title>Java String tutorial For Beginners</title>
<meta name="description" content="Java String tutorial for beginners.String in Java is the name of a memory location in which we can store the text" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java string,java string format,java string formatter,java string split,java string compareto,java stringbuilder,java string to int,string to int java,java string compare,java string length,java string array,java string reverse,javascript string,java string replaceall,java string methods,java string replace,java string equals,java string substring,java string contains,java string index,java string indexof,java string api,java string class,java string concatenation,java string trim,java string list,java string join,java string enum,java stringbuffer,java string to char array,java string append,java string to long
,java string sort,java string charat,java string size,java string to date,java string lowercase,java string functions,java string concat,java string valueof,java string declaration,java string interpolation,java string object,java string startswith,java string to double" />
<link rel="canonical" href="https://www.codeexampler.com/java-string" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">String in Java
</h1>
<div className="first">
        <a href="/java-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-literals">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, String in Java is the name of a memory location in which we can store the Text<br/>
2, The Text of string in Java can be change <br/>
3, Text or character enclosed  by double quotes <br/>
4, Create a variable of string type <br/>
 <br/>
</p>


<h2 className="headings">Q-Write a Program print a and b in java String example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-10">class</span>
          <span className="qwerty-4"> code</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Ram";</span>
 
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;String </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Lakshman";</span>
 
  {"\n"}
  
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">+</span>
        <span className="qwerty-4">" "</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Ram Lakshman </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">Java String Uppercase and Lowercase method<br/></h2>
<h3 className="mt-4 mh3 bold">toUpperCase()-</h3>
<p className="mt-3 para">uppercase Method used to convert a string into an uppercase string
</p>

<h2 className="headings">Q-Write a Program java in Uppercase() Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-2">String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Code Exampler";</span>
 
  {"\n"}
  
  <span className="qwerty-2">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">.</span>
        <span className="qwerty-6">toUpperCase</span>
        <span className="qwerty-1">()</span>
      <span className="qwerty-1">);</span>
      {"\n"}
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;CODE EXAMPLER </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h3 className="mt-4 mh3 bold">toLowerCase()- </h3>
<p className="mt-4 para">Lowercase Method used to convert a string into a lowercase string.<br/>
</p>



<h2 className="headings">Q-Write a Program java in Lowercase() Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-2">String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Code EXAMPLER";</span>
 
  {"\n"}
  
  <span className="qwerty-2">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">.</span>
        <span className="qwerty-6">toLowerCase</span>
        <span className="qwerty-1">()</span>
      <span className="qwerty-1">);</span>
      {"\n"}
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;code exampler </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">Java String Contains:</h2>
<h3 className="mt-4 mh3">Java String Contains() Method in  a string:<br/></h3>
<p className="mt-4 para">Contains () method is used to check Text means substring inside a string type variable, and this contains() method give output like: Boolean value.
</p>


<h2 className="headings">Java String Contains Example</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-2">String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Code Exampler";</span>
 
  {"\n"}
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">.</span>
        <span className="qwerty-6">contains</span>
        <span className="qwerty-1">(</span>
        <span className="qwerty-1">"Exampler"</span>
        <span className="qwerty-1">)</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">.</span>
        <span className="qwerty-6">contains</span>
        <span className="qwerty-1">(</span>
        <span className="qwerty-1">"exampler"</span>
        <span className="qwerty-1">)</span>
      <span className="qwerty-1">);</span>
      {"\n"}
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;true </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;false </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Java String length:<br/></h2>
<p className="mt-4 para"> Java String length to check the size of the string means to return the character of a string in the form of numbers.</p>


<h2 className="headings">Java string length Example</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-2">String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Code Exampler";</span>
 
  {"\n"}
  
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"The Character Length:"</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">.</span>
        <span className="qwerty-6">length</span>
        <span className="qwerty-1">()</span>
      <span className="qwerty-1">);</span>
      {"\n"}
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;The Character Length:</span><span className="qwerty-10">13  </span>       
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">Find a Java String character Location By using <span className="bold">indexOf()</span> :<br/></h2>
<h3 className="mt-4 mh3">Java string indexOf():</h3>
<p className="mt-4 para">Java string indexOf() Method used to check the start index position. <br/>
</p>




<h2 className="headings">Java string character Location</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-2">String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Code Exampler";</span>
 
  {"\n"}
  
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">.</span>
        <span className="qwerty-6">indexOf</span>
        <span className="qwerty-1">(</span>
        <span className="qwerty-1">"</span>
        <span className="qwerty-4">l</span>
        <span className="qwerty-1">"</span>
        <span className="qwerty-1">)</span>
      <span className="qwerty-1">);</span>
      {"\n"}
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}<span className="qwerty-10">&nbsp;10  </span>       
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Java substring<br/></h2>
<p className="mt-4 para">Return a substring from this instance. the substring starts at a specified character position.
</p>


<h2 className="headings">Java Substring Example:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-2">String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Code Exampler";</span>
 
  {"\n"}
  
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">.</span>
        <span className="qwerty-6">substring</span>
        <span className="qwerty-1">(</span>
        <span className="qwerty-4">4</span>
        <span className="qwerty-1">)</span>
      <span className="qwerty-1">);</span>
      {"\n"}
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}<span className="qwerty-3">&nbsp;Exampler </span>       
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>
    




<br/>

<h2 className="headings">Java another Substring Example:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-2">String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Code Exampler";</span>
 
  {"\n"}
  
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">.</span>
        <span className="qwerty-6">substring</span>
        <span className="qwerty-1">(</span>
        <span className="qwerty-4">4</span>
        <span className="qwerty-4">,</span>
        <span className="qwerty-4">8</span>
        <span className="qwerty-1">)</span>
      <span className="qwerty-1">);</span>
      {"\n"}
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}<span className="qwerty-3">&nbsp;Exa </span>       
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<br/>
<h2 className="mt-4 mh2"> Add a string format with integer:<br/></h2>


    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          
      {"\n"}
      <span className="qwerty-2">String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"Code Exampler";</span>
 
  {"\n"}
  <span className="qwerty-2">String </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8"> =</span>
    <span className="qwerty-1">"40";</span>
 
  {"\n"}
  
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}<span className="qwerty-3">&nbsp;Code Exampler <span className="qwerty-10">40</span> </span>       
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/java-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-literals">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jstring;